/**
 * Labstep
 *
 * @module components/Layout/Alert
 * @desc Components for alerting user
 */

import { LayoutAlertOfflineContent as OfflineContent } from 'labstep-web/components/Layout/Alert/OfflineContent';
import type React from 'react';
import LegacyDomain from './LegacyDomain';
import StagingContent from './StagingContent';

export const LayoutAlert: React.FC = () => (
  <div>
    <OfflineContent />
    <StagingContent />
    <LegacyDomain />
  </div>
);
